import { Link } from "react-router-dom";

import { theme } from "@/lib/theme";
import { cn } from "@/lib/utils";

interface CostDisclaimerProps {
  className?: string;
}

export default function CostDisclaimer({ className }: CostDisclaimerProps) {
  return (
    <div
      className={cn(
        "rounded-lg p-3 text-xs leading-relaxed text-gray-700 dark:text-gray-300 space-y-2",
        theme.borders.neubrutalism,
        "bg-gray-50 dark:bg-gray-800/50",
        className
      )}
    >
      <p>
        The cost shown is an estimate based on the number of episodes. Actual
        charges depend on audio duration and content complexity.
      </p>
      <p>
        By confirming, you authorize Podwise GPT to charge your credits or
        payment method up to this estimated amount. Transcription begins
        immediately and is non-refundable. New episodes after subscription are
        also automatically transcribed and billed.
      </p>
      <p>
        See our{" "}
        <Link
          to="/terms"
          className={cn("font-semibold hover:underline", theme.text.primaryOrange)}
        >
          Terms of Service
        </Link>{" "}
        for details.
      </p>
    </div>
  );
}
